import request from "../utils/fetch";
import {urlParamify} from '../api/index';

const GEO_NAMES_HOST = 'https://secure.geonames.org';
const GEO_NAMES_USER = 'mytoursapp';

export function geoNameAPI(method, params) {
  const qs = urlParamify({ ...params, username: GEO_NAMES_USER });
  const url = `${GEO_NAMES_HOST}/${method}?${qs}`;
  return request(url);
}


// WEBPACK FOOTER //
// ./webapp/scripts/geonames.js